import React, { useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { useStateValue } from './stateProvider/stateProvider';
import './index.css';
import './Componets.css';

import { allowAccess, setLocalStorage } from './utils/accessControl';
import ProtectedRoute from './elements/ProtectedRoute/ProtectedRoute';
import { SET_ROLES } from './constans/reducerActions';
import { GUEST, USER, ADMIN} from './constans/roles';

import App from './App';
import Login from './elements/Login/Login';
import Error_404 from './elements/Error_404/err';
import { ChooseTable } from './elements/ChooseTable/ChooseTable';
import Slideshow from './Slideshow/Slideshow';
import Home from './Home/Home';
import FooterGenerator from './footerGenerator/footerGenerator';
import UploadForm from './linkiKreator/linkiKreator';
import Register from './elements/Register/Register';


const Content = () => {
  const [state, dispatch] = useStateValue();

  useEffect(() => {
    let [token,userPermissions] = setLocalStorage()
  
      const roles = userPermissions ? userPermissions.split(',').filter(Boolean) : [];
      dispatch({ type: SET_ROLES, item: { roles } });
    
  }, [dispatch]);

  return (
    <HashRouter>
      <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={
                <ProtectedRoute
              allowedRole={ADMIN}
               path="/"
                redirectPath='/login'
            >
              <Register />
            </ProtectedRoute>
        
        } />


      <Route 
          path="/"
          element = {
            <ProtectedRoute
              allowedRole={GUEST}
               path="/"
                redirectPath='/login'
            >
              <Home/>
            </ProtectedRoute>
          } 
        />
    
        <Route 
          path="/panel"
          element = {
            <ProtectedRoute
              allowedRole={GUEST}
               path="/panel"
                redirectPath='/login'
            >
              <App />
            </ProtectedRoute>
          } 
        />

        
     
     <Route 
          path="/footer"
          element = {
            <ProtectedRoute
              allowedRole={GUEST}
               path="/footer"
                redirectPath='/login'
            >
              <FooterGenerator/>
            </ProtectedRoute>
          } 
        />
    
                <Route 
          path="/linki"
          element = {
            <ProtectedRoute
              allowedRole={USER}
               path="/linki"
                redirectPath='/login'
            >
              <UploadForm />
            </ProtectedRoute>
          } 
        />

                       <Route 
          path="/slideshow"
          element = {
            <ProtectedRoute
              allowedRole={GUEST}
               path="/slideshow"
                redirectPath='/login'
            >
              <Slideshow />
            </ProtectedRoute>
          } 
        />
      


        
        <Route path="/Choose" element={allowAccess()  ? <ChooseTable /> : <Login />} />
        <Route path="/*" element={<Error_404 />} />
      </Routes>
    </HashRouter>
  );
};

export default Content;